/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { Suspense, lazy,useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import { CookieSetting } from "cookiesetting-component";
import Navbar1 from "./components/Navbar1";
import WhySunwest from "./components/whySunwest";

// Lazy load non-critical components
const ApplyPage = lazy(() => import("./components/ApplyPage"));
const Footer = lazy(() => import("./components/FooterNew"));
// Loading fallback component
const LoadingFallback = () => <div className="loading-spinner">Loading...</div>;

 
function App() {
  const [showOtherComponents, setShowOtherComponents] = useState(false);
  const [showFooterAlways, setShowFooterAlways] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 10) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <BrowserRouter>
      <CacheBuster
        currentVersion={appversion.version}
        isEnabled={true}
        isVerboseMode={false}
        metaFileDirectory="."
      >
        <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
        />
        <div>
          <Navbar1 />
          <Routes>
            <Route path="/" element={<WhySunwest />} />
            <Route path="/why-sunwest" element={<WhySunwest />} />
            <Route path="/apply" element={<Home setShowFooterAlways={setShowFooterAlways} />} />
            <Route path="/why-sunwest/apply" element={<Home setShowFooterAlways={setShowFooterAlways} />} />
          </Routes>

          {/* Always show Footer for /apply and /why-sunwest/apply */}
          {showFooterAlways || showOtherComponents ? (
            <Suspense fallback={<LoadingFallback />}>
              <Footer />
            </Suspense>
          ) : null}
        </div>
      </CacheBuster>
    </BrowserRouter>
  );
}

function Home({ setShowFooterAlways }) {
  useEffect(() => {
    setShowFooterAlways(true);
    return () => setShowFooterAlways(false); // Reset when leaving the page
  }, [setShowFooterAlways]);

  return (
    <div>
      <Suspense fallback={<LoadingFallback />}>
        <ApplyPage />
      </Suspense>
    </div>
  );
}

export default App;
